import { addDays, differenceInDays, format, parseISO } from 'date-fns';

import { getTripEventsMinDate } from 'store/itinerariesItem/chronologicalDetails/utils';

import * as types from './recalculateRanges.types';
import { getImportOrganizedBy, getImportType } from './utils';

export const recalculateRangesForChronological = ({ importEvents, itineraryEvents, itineraryOrganizedBy }: any) => {
  const importOrganizedBy = getImportOrganizedBy(importEvents);
  const importType = getImportType(importOrganizedBy, itineraryOrganizedBy);

  switch (importType) {
    case types.ImportTypes.DatesToDates:
      return setDatesToDates(importEvents, itineraryEvents);
    case types.ImportTypes.DaysToDates:
      return setDaysToDates(importEvents, itineraryEvents);
    case types.ImportTypes.DatesToDays:
      return setDatesToDays(importEvents, itineraryEvents);
    case types.ImportTypes.DaysToDays:
      return setDaysToDays(importEvents, itineraryEvents);
  }
};

/**
 * ---- Dates(Import) to dates(Itinerary)
 * find earliest date in all events
 * recalculate all day ranges based on earliest date and event date
 *
 * ---- Days(Import) to dates(Itinerary)
 * find earliest date in Itinerary events
 * recalculate all dates ranges based on earliest date and event day
 *
 * ---- Dates(Import) to days(Itinerary)
 * ignore dates in Import events
 *
 * ---- Days(Import) to days(Itinerary)
 * ignore dates in Import events
 */

const setDatesToDates = (importItems: types.TripEvent[], itineraryItems: types.TripEvent[]) => {
  const earliestDate = getTripEventsMinDate([...importItems, ...itineraryItems]);

  const handledImportItems = importItems.map((item) => {
    const itemStartDate = parseISO(item.datesRange.start!);
    const itemEndDate = parseISO(item.datesRange.end!);

    const difference = differenceInDays(itemStartDate, parseISO(earliestDate!));

    const newStartDay = difference + 1;
    const newEndDay = newStartDay + differenceInDays(itemEndDate, itemStartDate);

    const newDaysRange = {
      start: newStartDay,
      end: newEndDay,
    };

    return {
      ...item,
      daysRange: newDaysRange,
    };
  });

  return [...itineraryItems, ...handledImportItems];
};

const setDaysToDates = (importItems: types.TripEvent[], itineraryItems: types.TripEvent[]) => {
  const earliestDate = getTripEventsMinDate(itineraryItems) || format(new Date(), 'yyyy-MM-dd');

  const handledImportItems = importItems.map((item) => {
    const itemStartDay = item.daysRange.start!;
    const itemEndDay = item.daysRange.end!;

    const newStartDate = addDays(parseISO(earliestDate!), itemStartDay - 1);
    const newEndDate = addDays(parseISO(earliestDate!), itemEndDay - 1);
    const newDatesRange = {
      start: format(newStartDate, 'yyyy-MM-dd'),
      end: format(newEndDate, 'yyyy-MM-dd'),
    };

    return {
      ...item,
      datesRange: newDatesRange,
    };
  });

  return [...itineraryItems, ...handledImportItems];
};

const setDatesToDays = (importItems: types.TripEvent[], itineraryItems: types.TripEvent[]) => {
  return [...itineraryItems, ...importItems];
};

const setDaysToDays = (importItems: types.TripEvent[], itineraryItems: types.TripEvent[]) => {
  return [...itineraryItems, ...importItems];
};
